import React, {  CSSProperties, ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';
import Loader from './loader';

export type TableData = {
  value: ReactNode;
  type?: 'default' | 'id';
  isRowID?: boolean;
  isCheckboxTD?: boolean;
};

export type TableProps = {
  columns: string[];
  data: TableData[][];
  className?: string;
  headClassName?: string;
  showTableHead?: boolean;
  rowClassName?: string;
  cellClassName?: string;
  highlightRows?: boolean;
  style?: CSSProperties | undefined;
  loading?: boolean;
  onRowClick?: (rowID: string | number) => void;
  emptyState?: ReactNode;
};

export const AppTable = ({
  columns,
  data,
  className,
  headClassName,
  highlightRows,
  rowClassName,
  loading = false,
  style,
  onRowClick,
  showTableHead = true,
  emptyState,
}: TableProps) => {
  return (
    <div className="bg-white overflow-x-auto overflow-y-auto no-scrollbar w-full">
      {loading ? (
        <div className='py-24 flex flex-col justify-center items-center'>
          <Loader width="2.5rem" borderTopColor="border-t-blue-500" />
        </div>
      ) : data.length ? (
        <table
          style={{ width: 'inherit', ...style }}
          className={`overflow-x-auto ${className}`}
        >
          {showTableHead && (
            <thead className="bg-gray-100">
              <tr className="border-b-[0.0625rem] border-gray-50 table-row">
                {columns.map((column, i) => (
                  <th key={`column-${column}-${i}`}>
                    <div
                      className={twMerge(
                        'px-[1.5rem] py-3 text-gray-text text-left',
                        headClassName,
                      )}
                    >
                      {column}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
          )}

          <tbody>
            {data.map((row, i) => (
              <tr
                key={`row-${i}`}
                className={`
                  border-t-[0.0625rem] border-gray-100 border-y-none h-[4.5rem] text-sm
                  ${highlightRows && i % 2 ? 'bg-gray-200' : 'bg-white'}
                  rowClassName
                  ${onRowClick ? 'cursor-pointer' : ''}
                  hover:bg-gray-100 hover:cursor-pointer`}
              >
                {row
                  .filter((value) => !value?.isRowID)
                  .map((value, j) => (
                    <td
                      key={`r-${i}-c-${j}`}
                      className="px-[1.5rem] py-4"
                      onClick={() => {
                        !row[j].isCheckboxTD &&
                          onRowClick?.(
                            (row.find((r) => r.isRowID)?.value as string) ?? '',
                          );
                      }}
                    >
                      {value.value}
                    </td>
                  ))}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="min-h-[30rem] flex items-center justify-center">
          {emptyState}
        </div>
      )}
    </div>
  );
};
